import React, { Fragment, useEffect, useRef, useState } from 'react';
import CreationBannerData from '../../model/creators/creationBannerData';
import RecommendMaterialGroup from '../../model/creators/recommendMaterialData';
import { CreatorsBannerSlider } from '../component/bannerSlider';
import { DownloadFile } from '../component/downloadFiles';

interface ViewProps{
    creationList: CreationBannerData[];
    materialGroup: RecommendMaterialGroup[];
    isSuccess: boolean;
}

const View: React.FC<ViewProps> = (props: ViewProps) => {

    useEffect(() => {
        const scriptUrl = document.createElement('script');
        scriptUrl.type = 'text/javascript';
        scriptUrl.src = '../assets/js/common.min.js';
        document.body.appendChild(scriptUrl);
    },[]);

    // BGMの参照配列と再生中インデックス
    const [playIndex, setIsPlaying] = useState(-1);
    const audio = useRef<HTMLAudioElement[]>([]);
    useEffect(() => {

        if (props.materialGroup.length > 0)
        {
            // レスポンスのカテゴリ名がBGMの時、中身を取得
            props.materialGroup[0].categoryList.forEach((category) => {
                if (category.category == "BGM")
                {
                    category.image.forEach ((content, index) => {
                        audio.current[index] = new Audio(`${process.env.REACT_APP_CHARA_IMAGE_URL}creators/${content.imageName}`);
                    })
                }
            })
        }
    },[props.isSuccess]);

    // 再生するBGMの管理
    useEffect(() => {

        audio.current.forEach ((content, index) => {
            // 再生中のBGMがあるか
            if (playIndex != -1)
            {
                if (index == playIndex)
                {
                    content.play();
                }
                else
                {
                    content.pause();
                    // ボタンが再生中状態かチェック
                    const btn = document.getElementById(`bgm_btn_${index}`);
                    if (btn?.classList.contains("playing"))
                    {
                        btn?.classList.toggle("no_playing");
                        btn?.classList.toggle("playing");
                    }
                }
            }
            else
            {
                content.pause();
            }
        });

    },[playIndex])

    // ボタンの状態変更と再生中インデックス更新
    function UpdatePlayBGM(index:number)
    {
        const btn = document.getElementById(`bgm_btn_${index}`);
        btn?.classList.toggle("no_playing");
        btn?.classList.toggle("playing");

        // 再生終了時のイベント登録
        audio.current[index].onended = function () {
            setIsPlaying(-1);
            btn?.classList.toggle("no_playing");
            btn?.classList.toggle("playing");
        }

        if (btn?.classList.contains("playing"))
        {
            setIsPlaying(index);
        }
        else
        {
            setIsPlaying(-1);
        }
    }


    return (
    <>
        <title>CREATORS | PROJECT ZIRCON（プロジェクト ジルコン） 公式サイト</title>
        
        <header id="konami_hd">
            <div className="inner">
                <h1 className="konami_logo"><a href="https://www.konami.com/games/jp/ja/" target="_blank"><img src="../assets/img/hd_logo_konami.svg" alt="KONAMI" /></a></h1>
            </div>
        </header>
        <div className="wrapper">
            <div className="gem_wrap back">
                <div className="gem" id="gem_back"></div>
            </div>
            <div className="gem_wrap front">
                <div className="gem" id="gem_front"></div>
            </div>
            <header id="incHd"></header>
            <main>
                <section className="subpage_header">
                    <div className="compass_wrap">
                        <p className="bg_compass"><img src="../assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058" /></p>
                    </div>
                    <h2 className="ttl_deco_side">
                        <span className="en">CREATORS</span>
                        <span className="jp">クリエイター</span>
                    </h2>
                </section>
                <section className="creators_contents_area">
                    <div className="inner">
                        <div className="sec fadeup">
                            <p className="catch">ルールを守れば商用利用もＯＫ<br />君もZIRCONを活用して<br className="sp-br" />クリエイターになろう!!</p>
                            <div className="btn_hexagon">
                                <a href="../guideline/">二次創作のガイドライン</a>
                            </div>
                        </div>
                        <div className="sec fadeup">
                            <h3 className="sec_ttl">
                                <span className="en">COMMUNITY PROJECT</span>
                                <span className="jp">コミュニティプロジェクト</span>
                            </h3>
                            <p className="read">「PROJECT ZIRCON（プロジェクト ジルコン）」ではプロジェクトを盛り上げるため<br />コミュニティメンバーが主導してくれている活動がいくつもあります！<br />特に顕著な活躍をされた方を表彰する制度もスタート！</p>
                        </div>
                        <section className="community_area fadeup">
                            <div className="bg_paper">
                                <div className="chara"><img src="../assets/img/web3/pfp_131.png" alt="ネオン" width="300" height="300"></img></div>
                                <div className="fukidashi">
                                    <p className="txt">『PROJECT ZIRCON』は「web3プロジェクト」という側面も持っています♪<br/>公式Discordコミュニティに参加して、コミュニティメンバーと交流したり、プロジェクトを進めるアイディアを出したりしてみてくださいね！<br/>コミュニティで貢献した人には豪華景品と交換できる「ジルコイン」が付与されますよ！</p>
                                </div>
                                <div className="btn_hexagon">
                                    <a href="https://discord.com/invite/jBEZnVp87Z" target="_blank">公式Discord</a>
                                </div>
                            </div>
                        </section>
                    <section className="creators_contents_banner sec fadeup">
                        <h3 className="elm_ttl">《 二次創作一覧 》</h3>
                        {CreatorsBannerSlider(props.creationList)}
                        <div className="swiper-button-next"></div>
                        <div className="swiper-button-prev"></div>
                        <div className="swiper-pagination"></div>
                    </section>
                    <section className="creators_contents_explanation">
                        <h3 className="elm_ttl">《 キャラクターの利用について 》</h3>
                        <div className="bg_box">
                            <p className="txt">PROJECT ZIRCONでは、皆さまの二次創作を心より歓迎しております。<br />ガイドラインに沿っていただければ、商用利用も含めて幅広くご活用いただけます。<br /><br />商用・非商用利用の詳細については、以下の「Q&A」をご参照ください。</p>
                        </div>
                        <div className="btn_hexagon">
                            <dd className="contents_detail_ttl">詳しくはコチラ</dd>
                            <a href="/guideline#イラスト利用のQ&A">キャラクター利用のQ&A</a>
                        </div>
                    </section>
                    <section className="creators_contents_material sec fadeup">
                        <div className="sec fadeup">
                            <h3 className="elm_ttl">《 以下の素材のご利用が可能です 》</h3>
                            <p className="material_explanation">こちらの素材一覧に掲載されているイラスト・データは、基本的にご自由にご利用いただけます。
                                <br />ご利用の際は、必ずガイドラインをご一読ください。
                                <br />個別の画像・BGMは、それぞれのファイル名をクリックすることでダウンロードが可能です。
                                <br />一括ダウンロードをご希望の方は、下のボタンからご利用ください。
                            </p>
                        </div>
                        <div className='material_btn_area'>
                            {/* 画像ダウンロードボタン */}
                            <div className="btn_hexagon" id="material_image">
                                <a href={`${process.env.REACT_APP_CHARA_IMAGE_URL}sozai.zip`} download={true}>画像をまとめてダウンロード</a>
                            </div>
                            {/* BGMダウンロードボタン */}
                            <div className="btn_hexagon" id="material_ngm">
                                <a href={`${process.env.REACT_APP_CHARA_IMAGE_URL}BGM.zip`} download={true}>BGMをまとめてダウンロード</a>
                            </div>
                        </div>

                        {
                            props.materialGroup.map((content, index) => {
                                return <Fragment key={index}>
                                    <h3 className="material_ttl">《 {content.type} 》</h3>
                                    <div className='recommended_material'>
                                        {
                                            content.categoryList.map((content, index) => {
                                                return <Fragment key={index}>
                                                    <details open>
                                                        <summary className='material_category'>{content.category}</summary>
                                                        <span className="category_line"></span>
                                                        <div className="material_list">
                                                            {
                                                                content.image.map((contentImage, index) => {
                                                                    
                                                                    return <Fragment key={index}>
                                                                        <div className="material_preview">
                                                                            {/* BGMか画像かで表示切り替え */}
                                                                            {
                                                                                content.category == "BGM"
                                                                                ?
                                                                                <>
                                                                                <div className="material_preview_image">
                                                                                    <button id={`bgm_btn_${index}`} className='no_playing' onClick={() => {UpdatePlayBGM(index)}}></button>
                                                                                    <button onClick={() => {DownloadFile(`${process.env.REACT_APP_CHARA_IMAGE_URL}creators/${contentImage.imageName}`,contentImage.imageName)}}>
                                                                                        <p>{contentImage.drawName}</p>
                                                                                    </button>
                                                                                </div>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                <div className="material_preview_image">
                                                                                    <img src={`${process.env.REACT_APP_CHARA_IMAGE_URL}creators/${contentImage.imageName}`} alt={contentImage.imageName}/>
                                                                                    <button onClick={() => {DownloadFile(`${process.env.REACT_APP_CHARA_IMAGE_URL}creators/${contentImage.imageName}`,contentImage.imageName)}}>
                                                                                        <p>{contentImage.drawName}</p>
                                                                                    </button>
                                                                                </div>
                                                                                </>
                                                                            }             
                                                                        </div>
                                                                    </Fragment>
                                                                })
                                                            }
                                                        </div>
                                                    </details>
                                                </Fragment>
                                            })
                                        }
                                    </div>
                                </Fragment>
                            })
                        }
                    </section>
                </div>
                </section>
            </main>
            <footer id="incFt"></footer>
        </div>
    </>
    );
};

export default View;